import script from "./FaqView.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqView.vue?vue&type=script&setup=true&lang=js"

import "./FaqView.vue?vue&type=style&index=0&id=d7a5ee7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7a5ee7a"]])

export default __exports__